<template>
  <div class="container">
    <div class="top-box">
      <div class="logo-box">
        <img src="../assets/pc/top-bg.png" alt="背景图" class="top-bg wow animate__animated animate__fadeIn"
             data-wow-duration="3s"/>
        <div class="sun-box">
          <div class="sun">
            <img src="../assets/pc/light.png" class="light">
            <img src="../assets/pc/face.png" class="face">
          </div>
        </div>
      </div>
<!--      <div ref="target" class="slogan-box">-->
<!--        <img src="../assets/pc/slogan-yellow.png" alt="花蹊标语" v-for="(item, index) in 17" :key="index"-->
<!--             :class="{'slogan':true} " :style="{bottom: isInView ? index*20 + 'px' : 0}"/>-->
<!--        <img src="../assets/pc/slogan-white.png" alt="花蹊标语" class="slogan"-->
<!--             :style="{bottom: isInView ? 16*20 + 'px' : 0}"/>-->
<!--      </div>-->
<!--      <div class="class-info">-->
<!--        <img src="../assets/pc/class1.png" alt="展览班" class="class1 wow animate__animated animate__flipInY"/>-->
<!--        <img src="../assets/pc/class2.png" alt="共探班" class="class1 wow animate__animated animate__flipInY"-->
<!--             data-wow-delay=".8s"/>-->
<!--        <img src="../assets/pc/class3.png" alt="专业班" class="class1 wow animate__animated animate__flipInY"-->
<!--             data-wow-delay="1.6s"/>-->
<!--        <img src="../assets/pc/class4.png" alt="创作班" class="class1 wow animate__animated animate__flipInY"-->
<!--             data-wow-delay="2.4s"/>-->
<!--      </div>-->
<!--      <img src="../assets/pc/works-1.png" alt="部分学生作品" class="works-1 wow animate__animated animate__fadeInDown"/>-->
    </div>
<!--    <div class="background"></div>-->
    <img src="../assets/common/mini-title.png" alt="4岁-18岁" class="works-2"/>
    <img src="../assets/common/mini.jpg" alt="4岁-18岁"
         class="student-works wow animate__animated animate__zoomIn"/>

    <img src="../assets/common/infant-title.png" alt="幼儿部" class="works-2" style="width: 270px"/>
    <div class="layout-box">
      <img src="../assets/common/infant_left.jpg" alt="幼儿部"
           class="imgw wow animate__animated animate__zoomIn"/>
      <img src="../assets/common/infant_right.jpg" alt="幼儿部"
           class="imgw wow animate__animated animate__zoomIn"/>
    </div>

    <img src="../assets/common/primary-title.png" alt="小学部" class="works-2" style="width: 430px"/>
    <div class="teacher-works-box">
      <img src="../assets/common/primary.jpg" alt="小学部"
           class="teacher-works wow animate__animated animate__zoomIn"/>
    </div>

    <img src="../assets/common/middle-title.png" alt="初中部" class="works-2" style="width: 470px"/>
    <img src="../assets/common/middle.jpg" alt="初中部"
         class="student-works wow animate__animated animate__zoomIn"/>

    <img src="../assets/common/senior-title.png" alt="高中部" class="works-2" style="width: 940px"/>
    <img src="../assets/common/senior.jpg" alt="高中部"
         class="student-works wow animate__animated animate__zoomIn"/>

    <img src="../assets/common/concat.png" alt="联系我们" class="works-2" style="width: 240px"/>
    <div class="footer wow animate__animated animate__slideInUp">
      <div class="left">
        <img src="../assets/common/qr.jpg" class="qr"/>
        <img src="../assets/common/mobile.png" class="mobile"/>
      </div>
      <div class="right">
        <img src="../assets/common/campus.png" alt="花蹊校区" class="campus"/>
      </div>
    </div>
    <div class="footer-bottom">
      <img src="../assets/common/address.png" alt="花蹊" class="address"/>
      <div class="beian">工信部备案：<a href="https://beian.miit.gov.cn/" target="_blank"> 豫ICP备2023023142号-1</a>
      </div>
    </div>

  </div>
</template>

<script>
import {WOW} from 'wowjs'

export default {
  name: "pc-index",
  data() {
    return {
      isInView: false,
    }
  },

  mounted() {
    new WOW().init()
    this.$nextTick(() => {
      window.addEventListener('scroll', this.checkIfInView);
    });
  },
  methods: {
    checkIfInView() {
      const target = this.$refs.target;
      if (!target) return
      const rect = target.getBoundingClientRect();
      const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
      const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
      if (rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth) {
        this.isInView = true;
      }
      if (rect.bottom < 0) {
        this.isInView = false
      }
    },
  },

}
</script>

<style scoped>
.sun-box {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sun {
  width: 16%;
  position: relative;
}

.logo-box {
  position: relative;
}

.light {
  width: 100%;
  animation: rotate 10s linear infinite normal;
  transform-origin: center;
}

@keyframes rotate {

  0% {

    transform: rotate(0deg);
  }

  100% {

    transform: rotate(360deg);
  }
}

.face {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}


.container {
  min-width: 1320px;
}
.top-box {
  background-color: #e8490f;
  font-size: 0;
  position: relative;
  padding-bottom: 1px;
}

.top-bg {
  width: 100%;
}


.student-works {
  width: 83%;
  max-width: 1586px;
  margin: 50px auto 20px;
}

.works-2 {
  width: 300px;
  margin: 140px auto 30px;
}

.imgw {
  width: 50%;
}

.layout-box{
  width: 80%;
  max-width: 1555px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}

.teacher-works {
  width: 80%;
  max-width: 1555px;
  margin: 0 auto;
}

.footer {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
.footer .left{
  width: 500px;
}
.qr{
  width: 220px;
  margin: 0 auto;
}
.mobile{
  width: 260px;
  margin: 15px auto 0;
}
.campus {
  width: 460px;
}

.footer-bottom{
  background-color: #fe4e02;
  text-align: center;
  font-size: 34px;
  padding-top: 30px;
  margin-top: 100px;
}

.address{
  width: 200px;
  margin: 0 auto 10px;
}

.right {
  font-size: 28px;
  letter-spacing: 2px;
}

.beian {
  font-size: 14px;
  text-align: center;
  margin-top: 30px;
}

.beian a {
  color: #ffffff;
}
</style>
